export const BASE_TIMER_TIME = 300;
export const LINE_WIDTH_FOR_1280P = 12;
export const BLUE = '#0E72ED';
